import '../css/postLayout.css';
import '../css/rightSidebar.css';

const RightSidebar = ({ title, relatedPosts }) => {
  return (
    <div id="right-sidebar" className="fix-sidebar mb-3">
      <div className="card related-posts">
        <div className="card-header"> Bài viết liên quan </div>
        <ul className="card-body m-0">
          {relatedPosts.map((post, index) => (
            <li key={post.id} className="card-item mb-3">
              <a
                href={`/${title}/${post.slug}`}
                title={post.title}
                className="d-block w-100 image"
              >
                <img
                  src={post.thumbnail}
                  alt={post.title}
                  className="w-100 "
                  loading="lazy"
                />
              </a>
              <a href={`/${title}/${post.slug}`} className="title-related-post">
                {post.title}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default RightSidebar;
